'use client';

import { Box, Link, Typography } from '@mui/material';
import type { MouseEvent } from 'react';

export function BackToTopLink() {
  return (
    <Link
      onClick={(e: MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }}
      href="#"
      alignSelf="center"
      color="primary.main"
      display={{ xs: 'none', sm: 'block' }}
    >
      <Box display="flex" gap={1}>
        <Typography variant="accent" noWrap>
          BACK TO TOP
        </Typography>
        <Box
          component="span"
          className="mask-icon mask-icon-vertical-align-top"
          data-testid="arrow-up-icon"
          sx={{ width: 16, height: 16, backgroundColor: 'primary.main' }}
        />
      </Box>
    </Link>
  );
}
